// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"484088aa","453":"36fd764b","744":"484088aa"}[chunkId] + ".chunk.js";
};